import React from "react";
import PropTypes from "prop-types";

import {getRuleMeaning, FILTER_KEYS} from "../../../../../services/filterRules";

import {Badge, Box, Grid, IconButton, Typography} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import MailIcon from '@mui/icons-material/Mail';


const DefaultRule = props => {
    const {rule, onShowRequests, onDelete} = props;

    const totalFilteredRequestsNotOld = rule[FILTER_KEYS.totalFilteredRequestsNotOld];

    const handleDelete = (event) => {
        event.preventDefault();
        onDelete(rule.id, false)
    };

    const handleShowRequests = (event) => {
        event.preventDefault();
        onShowRequests(rule.id)
    };

    const formatter = (value) => (
        <Box component="span" sx={{color: "primary.main"}}>
            {value}
        </Box>
    );

    return (
        <Grid container
              justifyContent="space-between"
              alignItems="stretch">

            <Grid item xs={12} sm={9} md={10}>
                <Box sx={{py: 2, display: "flex", alignItems: "center", height: "100%"}}>
                    <Typography variant="body1">
                        {
                            getRuleMeaning(rule, formatter).map((p, i) => (
                                    <React.Fragment key={i}>{p}</React.Fragment>
                                )
                            )
                        }
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={3} md={2}>
                <Box sx={{display: "flex", justifyContent: "flex-end", alignItems: "center", height: "100%"}}>
                    <IconButton
                        aria-label="Richieste filtrate"
                        onClick={handleShowRequests}>
                        <Badge color="primary" badgeContent={totalFilteredRequestsNotOld} max={99}>
                            <MailIcon/>
                        </Badge>
                    </IconButton>

                    <IconButton
                        aria-label="Cancella"
                        onClick={handleDelete}>
                        <DeleteIcon/>
                    </IconButton>
                </Box>
            </Grid>
        </Grid>
    )
};

DefaultRule.propTypes = {
    rule: PropTypes.object.isRequired,
    onShowRequests: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export {DefaultRule}